import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  tooltipLabel: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    color: colors.white,
  },
  tooltipCenterContent: {
    textAlign: 'center',
    width: '100%',
  },
  defaultInputBGColor: {
    backgroundColor: colors.white,
  },
  root: {
    '& .MuiInputBase-root': {
      padding: '0px 9px !important',
      height: 'auto',
      minHeight: 59,
      width: '100%',
      backgroundColor: colors.white,
    },
  },
  hasItemSelected: {
    '& .MuiInputBase-root': {
      padding: '9px 9px !important',
      overflow: 'hidden',
      backgroundColor: colors.white,
    },
  },
});

export default useStyles;
